//MARK: Done
export const JOB = {
  JOB: {
    PAGE: "job/page",
    UPDATE: { STATE: "job/update/state" },
  },
};
